import { render, staticRenderFns } from "./BookingVoyages.vue?vue&type=template&id=2306669f&"
import script from "./BookingVoyages.vue?vue&type=script&lang=js&"
export * from "./BookingVoyages.vue?vue&type=script&lang=js&"
import style0 from "./BookingVoyages.vue?vue&type=style&index=0&id=2306669f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports